import { HttpContextToken } from '@angular/common/http';
import { InjectionToken } from '@angular/core';

/** Set on a request that stays open on purpose (the live streams), so a host's "busy" spinner does not wait for it to finish. */
export const INBOX_NO_SPINNER = new HttpContextToken<boolean>(() => false);

/** Base URL of the Inbox API (drafts, searches, execution logs, uploads). Each host provides it. */
export const INBOX_BASE_URL = new InjectionToken<string>('INBOX_BASE_URL');

/** Where the Inbox pages live in the router, so the components never hard-code a path. Each host provides it. */
export interface InboxPaths { list: string; record: (id: string) => string[]; }
export const INBOX_PATHS = new InjectionToken<InboxPaths>('INBOX_PATHS');
